import { STAGES, type Stage } from "../domain/stages.ts";
import type { BuilderApi } from "./api.ts";
import { useNav } from "./nav.tsx";
import { EmployeeList } from "./screens/EmployeeList.tsx";
import { NewEmployee } from "./screens/NewEmployee.tsx";
import { EmployeeShell } from "./screens/EmployeeShell.tsx";

/**
 * Every builder screen, routed off the current path. Mount inside a
 * <NavProvider base="..."> so it works at any prefix in any host.
 */
export function BuilderRoutes({ api }: { api: BuilderApi }) {
  const { path } = useNav();
  if (path === "/new") return <NewEmployee api={api} />;
  const m = /^\/employees\/([^/]+)(?:\/([a-z]+))?\/?$/.exec(path);
  if (m) {
    const stage = STAGES.includes(m[2] as Stage) ? (m[2] as Stage) : undefined;
    return <EmployeeShell key={m[1]} api={api} id={m[1]} stage={stage} />;
  }
  return <EmployeeList api={api} />;
}
